import { createFileRoute } from "@tanstack/react-router";
import { useSimpleForm } from "@/hooks/use-simple-form";
import useAppStore from "@/store";
import { useEffect } from "react";
import { ChevronLeft, Loader2 } from "lucide-react";
import DataPlaceholder from "@/components/ui/shared/data-placeholder";
import StockTransferTable from "@/components/stock-transfer/stock-transfer-table";
import { useTranslate } from "@/hooks/use-translate";
import type { StockBatch } from "@/store/StockBatch";

export const Route = createFileRoute(
  "/(dasboard)/inventory/stock-batchs/$id/quantity-transfer-in"
)({
  component: QuantityTranferInPage,
});

function QuantityTranferInPage() {
  const store = useAppStore();
  const stock_batch = store.stockBatch.current;
  const params = Route.useParams();
  const { t } = useTranslate();

  const searchForm = useSimpleForm({
    keyword: undefined,
  });

  const search = ({ page = 1, per_page = 10, stock_batch_id }: any = {}) => {
    store.stockTransfer.fetch({
      page,
      per_page,
      receiver_batch_id: stock_batch_id,
      ...searchForm.values,
    });
  };

  useEffect(() => {
    const id = params.id;
    if (id && store.auth.session) {
      store.stockBatch
        .fetchOne(id)
        .then((stock_batch: StockBatch) => {
          store.stockBatch.setCurrent(stock_batch);
          search({ stock_batch_id: id });
        })
        .catch(store.errors.catch);
    }
  }, [params.id, store.auth.session]);

  if (!stock_batch) {
    return (
      <section>
        <>{store.errors.render()}</>
        <div className="h-24 bg-gray-200 rounded-md flex items-center justify-center">
          {store.loading.status.quantity ? (
            <div>
              <Loader2 className="animate-spin text-primary-400 mx-auto" />
              <p className="text-gray-600">{t("Loading...")}</p>
            </div>
          ) : (
            <div>
              <DataPlaceholder />
            </div>
          )}
        </div>
      </section>
    );
  }

  return (
    <section>
      <div>
        <button
          type="button"
          onClick={() => window.history.back()}
          className="py-2 inline-flex gap-2 items-center justify-center rounded-lg text-sm text-gray-500 hover:text-gray-900 hover:underline font-semibold"
        >
          <ChevronLeft className="h-4 w-4" />
          <span className="">{t("Back")}</span>
        </button>
      </div>
      <h3 className="font-semibold mb-2"> {t("Quantity Tranfered In")} </h3>
      <StockTransferTable fetch={() => {}} />
    </section>
  );
}
